<template>
  <!--我的会议-->
  <div class="content my-meeting">
    <div class="layui-fluid">
      <div class="layui-row">
        <div class="layui-col-md12">
          <!--面包屑-->
          <div style="margin-left: 20px;">
            <el-breadcrumb separator-class="el-icon-arrow-right">
              <el-breadcrumb-item>会议专题</el-breadcrumb-item>
            </el-breadcrumb>
          </div>
          <!--下拉框-->
          <div
            class="layui-row top"
            style="margin-top:20px"
          >
            <!-- 我的会议搜索 START-->
            <div class="layui-col-md8">
              <form
                class="layui-form"
                action
                lay-filter="component-form-group"
              >
                <div class="layui-col-md5">
                  <div class="layui-form-item">
                    <label class="layui-form-label">专题名称:</label>
                    <div class="layui-input-block">
                      <input
                        type="text"
                        required                       
                        lay-verify="required"
                        placeholder="请输入专题名称"
                        autocomplete="off"
                        class="layui-input"
                        v-model="meet_name"
                      />
                    </div>
                  </div>
                </div>
                <div class="layui-col-md5">
                  <div class="layui-form-item">
                    <label class="layui-form-label">状态:</label>
                    <div class="layui-input-block">
                      <el-select
                        v-model="value_status"
                        placeholder="请选择"
                      >
                        <el-option
                          value=""
                          label="请选择"
                        ></el-option>
                        <el-option
                          v-for="item in options"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        >
                        </el-option>
                      </el-select>
                    </div>
                  </div>
                </div>
                <div class="layui-col-md-offset1">
                  <el-button @click="meet_sou(cur,meet_name,value_status)" type="primary">搜索</el-button>
                </div>
              </form>
            </div>
            <!-- 我的会议搜索 END-->
            <div class="layui-col-md1 layui-col-md-offset1 the-meeting">          
              <el-button @click="gonew" type="primary">新建会议专题</el-button>
            </div>
          </div>
        </div>
        <h5 style="font-size:18px;margin-left:20px">专题列表</h5>
        <!--专题列表-->
        <loading-tip :show-load="loading"></loading-tip>
        <div
          v-show="fromation=='' && !loading"
          style="width: 100%;
          text-align: center;
        padding: 40px 0px;
        color: #bab1b1;"
        >无相关数据！</div>
        <div
          v-show="!loading"
          v-for="(item,index) in fromation"
          :key="index"
        >
          <div
            class="layui-row top"
            style="border-bottom: 1px solid #ccc;padding-bottom: 20px;margin-bottom: 20px;margin-left:20px"
          >
            <div class="layui-col-md8">
              <div class="layui-row">
                <div class="layui-col-md3 layui-col-xs6">
                  <div class="img_left meeting_img">
                    <img
                      :src="item.cover_url"
                      alt
                      width="100%"
                      style="border: 1px solid #ccc;display: block;height:150px"
                    />
                  </div>
                </div>
                <div class="layui-col-md layui-col-xs6">
                  <div style="margin-left: 60px;margin-top: 10px">
                    <p class="layui-elip">{{item.title}}</p>
                    <p class="layui-elip">{{item.desc}}</p>
                    <p
                      class="layui-elip"
                      v-if="item.status==0"
                    >
                      <el-tag type="danger">禁用</el-tag>
                    </p>
                    <p
                      class="layui-elip"
                      v-else
                    >
                      <el-tag type="success">正常</el-tag>
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="layui-col-md4 shiyan">
              <div style="margin-top: 10px">
                <div>              
                  <el-button size="medium" type="primary" @click="goedit(item.id)">编辑</el-button>
                </div>
              </div>
            </div>
            <div class="layui-col-md4 shiyan">
              <div style="margin-top: 10px">
                <div>                
                  <el-button size="medium" type="primary"  @click="clickmeet(item.id)">关联会议</el-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--分页-->
      <div style="display: flex;
             justify-content: center;">
        <el-pagination
          @current-change="handleCurrentChanges"
          :current-page="cur"
          :page-sizes="[8]"
          :page-size="8"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalPage"
        >
        </el-pagination>
      </div>
    </div>
    <!-- 关联会议弹出框 -->
    <el-dialog
      width="800px"
      title="关联会议"
      :close-on-click-modal="false"
      :visible.sync="dialogTableVisible"
    >
   <!--   <el-transfer
        filterable
        :titles="['未关联会议', '已关联会议']"
        :button-texts="['取消关联', '关联']"
        filter-placeholder="请输入会议名称"
        v-model="values"
        :data="data"
        @change="listchang"
      >
      </el-transfer>-->

      <div class="guanlian_container">
        <div class="guanlian_item">
          <h5>未关联会议</h5>
          <el-checkbox-group v-model="guanlian" @change="changeSelect">
          <el-table id="weidata" ref="weidata" :data="data" style="width: 100%;margin-bottom: 20px;" row-key="key" border  max-height="350">
            <el-table-column align="center" prop="key" label="ID" width="80">
              <template slot-scope="scope">
                <el-checkbox :label="scope.row.key"></el-checkbox>
              </template>
            </el-table-column>
            <el-table-column prop="label" align="center" label="会议名" >
            </el-table-column>
          </el-table>
        </el-checkbox-group>
        </div>
        <div class="guanlian_item">
          <h5>已关联会议</h5>
          <el-table id="guanlianData" :data="guanlianData"  style="width: 100%;height:350px;margin-bottom: 20px;" row-key="key" border  max-height="350">
            <el-table-column align="center" label="排序" width="80">
              <template slot-scope="scope">
<input type="text" v-model="scope.row.sort" class="paixu" @change="paixu">
              </template>
            </el-table-column>
            <el-table-column prop="key" align="center" label="ID" width="80">
            </el-table-column>
            <el-table-column prop="label" align="center" label="会议名">
            </el-table-column>
          </el-table>
        </div>
      </div>

     <div style="text-align:right;">
       <el-button
                  type="primary"
                  style="margin-top:10px;background-color: #009688;"
                  @click="savemeet"
                  >保存</el-button>
     </div>
    </el-dialog>
  </div>
</template>

<script>
import $ from "jquery";
import loadingTip from "../LoadingTip/loadingTip";
export default {
  name: "Special",
  data () {
    return {
      id: "",
      data: [],
      valarr: [],
      values: [],
      options: [
        {
          value: 0,
          label: ' 禁用'
        }, {
          value: 1,
          label: ' 正常'
        }],
      value_status: "",
      /* 弹出框 */
      dialogTableVisible: false,
      loading: false,
      fromation: [],
      cur: 1, //当前页码
      totalPage: 8, //当前条数
      type_meet: "",
      meet_name: "",
      n_data: "",

      guanlian:[],//已关联会议
      guanlianData:[],//关联的会议信息
    };
  },
  components: { loadingTip },
  computed: {

  },
  created () {
    this.initMeetingInformation(this.meet_name, this.value_status)
    this.meetlist()
  },
  methods: {
    /*专题列表分页 */
    handleCurrentChanges (val) {
      var _this = this
      _this.cur = val
      _this.initMeetingInformation()
    },
    /*关联会议 */
    listchang (value, direction, movedKeys) {
      var _this = this
      var arr = []
      var allid = _this.valarr
      if (direction === "left")
      {
        for (let i = 0; i < allid.length; i++)
        {
          if (_this.values.indexOf(allid[i].c_id) == -1)
          {
            arr.push(allid[i].id)
          }
        }
        var url = _this.APIurl.API.api.quxiaomeet
        var params = {
          id: arr
        }
        _this.$post(url, params).then(res => {
          if (res.code == 1)
          {
            _this.$message({
              message: '取消关联成功',
              type: 'success',
              duration: 1000
            });
          }
        })

      }
    },
    /* 保存关联会议 */
    savemeet () {

      var _this = this
      if (_this.guanlian.length > 0)
      {
        var url = _this.APIurl.API.api.baocunmeet
        var params = {
          subject_id: _this.id,
          conference_ids: _this.guanlian,
        }
        _this.$post(url, params).then(res => {
          if (res.code == 1)
          {
            _this.$message({
              message: '关联成功',
              type: 'success',
              duration: 1000
            });
            _this.dialogTableVisible = false
          }
        })
      } else
      {
        _this.$message({
          message: '无关联会议',
          type: 'warning',
          duration: 1000
        });
      }


    },
    /* 会议列表 */
    meetlist () {
      var _this = this
      let url = _this.APIurl.API.api.meeting_list;
      let params = {
        pagesize: 10000, //每页条数
        page: 1, //当前页
      };
      _this.$get(url, params).then(res => {
        if (res.code == 1)
        {
          res.posts.list.forEach((item, index) => {
            _this.data.push({
              label: item.name,
              key: item.id,
              pinyin: item.id,
              sort:0
            });
          });
        }
      })

    },
    /* 关联会议 */
    clickmeet (id) {
      var _this = this
      var arrs = []
      var arrnew = [],guanlianbox=[];
      _this.id = id
      var url =  _this.APIurl.API.api.guanlianlists
      var params = {
        subject_id: id,
        name: ""
      }
      _this.guanlianData = [];
      _this.$get(url, params).then(res => {
        if (res.code == 1)
        {
          var arr = res.posts.data
          var obj = {}
          for (let i = 0; i < arr.length; i++)
          {
            arrs.push(arr[i].c_id)
            obj = {
              id: arr[i].id,
              c_id: arr[i].c_id
            }
            arrnew.push(obj)
            guanlianbox.push(arr[i].c_id)
            _this.guanlianData.push({
              label: arr[i].name,
              key: arr[i].c_id,
              sort:i
            });
          }
          _this.values = arrs
          _this.valarr = arrnew
          _this.guanlian = guanlianbox
        }
      })
      _this.dialogTableVisible = true
    },
    /* 新建专题 */
    gonew () {
      var _this = this
      _this.$router.push("/admin/Newspecial")
    },
    /* 编辑 */
    goedit (myId) {
      var _this = this
      _this.$router.push({
        path: "/admin/Newspecial",
        query: { editId: myId, cur: _this.cur }
      });
    },
    //查看详情
    handleCheckTheDetails (myId) {
      var _this = this
      _this.$router.push({
        path: "/admin/Bmjigou",
        query: { editId: myId, cur: _this.cur }
      });
    },
    // 专题列表
    initMeetingInformation (names, status) {
      var _this=this
      let url = _this.APIurl.API.api.zhuantilist
      var params = {}
      params = {
        name: names,
        status: status,
        pagesize: "8", //每页条数
        page: this.cur, //当前页      
      };
      this.loading = true;
      this.$get(url, params)
        .then(res => {
          if (parseInt(res.code) === 1)
          {
            this.fromation = res.posts.data;
            this.totalPage = res.posts.count;
            this.cur = res.posts.page;
          } else
          {
            layer.msg(res.msg);
          }
          this.loading = false;
        })
        .catch(error => {
          console.log(error);
        });
    },
    /* 搜索 */
    meet_sou (name, status) {
      this.initMeetingInformation(name, status)
    },
    changeSelect(e){
      this.guanlianData = [];
      for(var i=0;i<e.length;i++){
        this.data.forEach(item =>{
          if(item.key == e[i]){
            item.sort = i;
            this.guanlianData.push(item);
          }
        })
      }

    },
    paixu(){
      function compare(prop){
        return function(a,b){
          let value1 = Number(a[prop]);
          let value2 = Number(b[prop]);
          return  value1 - value2;
        }
      }
      var newbox =   this.guanlianData.sort(compare('sort'));
      this.guanlian = [];
      newbox.forEach(e =>{
        this.guanlian.push(e.key);
      })
    }
  },
  mounted () {
  },
  updated () {
  }
};
</script>

<style scoped>
.el-transfer /deep/ .el-transfer-panel {
  width: 300px;
}
li.router-link-exact-active {
  color: #8fc526 !important;
}
/*分页*/
.page-bar {
  margin: 40px auto;
  margin-top: 20px;
}
ul,
li {
  margin: 0px;
}
li {
  list-style: none;
}
.page-bar li:first-child > a {
  margin-left: 0px;
}
.page-bar a {
  border: 1px solid #ddd;
  text-decoration: none;
  position: relative;
  float: left;
  padding: 6px 12px;
  margin-left: -1px;
  line-height: 1.42857143;
  color: #5d6062;
  cursor: pointer;
  margin-right: 20px;
}
.page-bar a:hover {
  background-color: #eee;
}
.page-bar a.banclick {
  cursor: not-allowed;
}
.page-bar .active a {
  color: #fff;
  cursor: default;
  background-color: #009688;
  border-color: #009688;
}
.page-bar i {
  font-style: normal;
  color: #009688;
  margin: 0px 4px;
  font-size: 12px;
}
/*分页结束*/
.my-meeting {
  background: #ffffff;
}
.content .top {
  margin-top: 4px;
}
.content .layui-form-label {
  padding: 9px 0;
}
.my-meeting .img_left {
  position: relative;
}
.my-meeting .inthemeeting {
  position: absolute;
  top: 0px;
  left: 103px;
}
/* 列表图片 */
.meeting_img {
  position: relative;
}
/* 列表图片上的文字 */
.meeting_img_text {
  position: absolute;
  top: 0;
  right: 0;
  left: auto !important;
  padding: 0px 15px 0px 15px;
}

.shiyan {
  display: flex;
  align-items: center !important;
}
@media screen and (min-width: 320px) and (max-width: 750px) {
  .my-meeting .the-meeting {
    margin-top: 10px;
    margin-bottom: 10px;
  }
  .my-meeting .layuiedit {
    margin-top: 10px;
  }
}
  .guanlian_container{
    width: 100%;
    display: -webkit-box;
  }
  .guanlian_container .guanlian_item{
    flex: 1;
    margin-right: 40px;
  }
  .guanlian_container .guanlian_item:nth-child(2n){
    margin-right: 0px;
  }
  .guanlian_container  .paixu{
    width:40px;
    padding:0 5px;
    border: 1px solid #ebebeb;
    text-align: center;
    color: #999;
  }
</style>
